/** Returns the Monday of the week containing the given date */
export const getWeekStart = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = day === 0 ? -6 : 1 - day;
    d.setDate(d.getDate() + diff);
    d.setHours(0, 0, 0, 0);
    return d;
};

export const formatDateValue = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

export const isDateRestricted = (targetDate, futureDateRestrict) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const checkDate = new Date(targetDate);
    checkDate.setHours(0, 0, 0, 0);

    const twoWeeksFromToday = new Date(today);
    twoWeeksFromToday.setDate(today.getDate() + 14);

    if (futureDateRestrict === true) {
        return checkDate > twoWeeksFromToday;
    } else {
        return false;
    }
};

export const findMatchingWeekEnding = (targetDate, rosterData) => {
    if (!rosterData || rosterData.length === 0) return null;

    const targetDateStr = formatDateValue(targetDate);

    for (const shift of rosterData) {
        if (!shift.weekEnding) continue;

        const existingDate = new Date(shift.weekEnding);
        const existingDateStr = formatDateValue(existingDate);

        if (existingDateStr === targetDateStr) {
            return shift.weekEnding;
        }
    }

    return null;
};

export const calculateShiftHours = (shiftStart, shiftFinish) => {
    const start = new Date(shiftStart);
    const end = new Date(shiftFinish);
    return (end - start) / (1000 * 60 * 60);
};

export const getDatesInWeek = (dateFilters) => {
    const dates = [];
    const startDate = new Date(dateFilters.shiftStart);
    const endDate = new Date(dateFilters.shiftFinish);

    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
};

export const formatLocalDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const normalizeDate = formatLocalDate;
